/* eslint-disable lingui/no-unlocalized-strings -- Approved First Round plan copy. */
import { type FirstRoundMe, formatPlanDate } from "@/client/services/pricing/first-round";

/** The "you've got a pass" message after a code, a card payment or an upgrade. */
export const passWelcome = (me: FirstRoundMe) => {
  if (!me.pass) return null;
  const interviews =
    me.practice.limit === null
      ? "Unlimited practice interviews"
      : `${me.practice.limit} practice interview${me.practice.limit === 1 ? "" : "s"}`;
  return {
    title: `Welcome to ${me.pass.planName}`,
    description:
      me.pass.state === "unstarted"
        ? `${interviews}. Your ${me.pass.accessDays} days start with your first one.`
        : `${interviews}, until ${formatPlanDate(me.pass.endsAt)}.`,
  };
};
